<template>
    <!--
        -----------------------
        以下的内容是有关 el-carousel 的使用说明：
         1. 项目开发的时候，height 和 width 根据图片的尺寸动态注入；height 默认为 0，width 主要控制 next 和 prev 的展示宽度
         2. 注意：
            2.1 el-carousel 的 width 样式必须设置，一是用来设置 carousel 的两个左右按钮位置的，而是设置要展示区域的宽度，通过 .el-carousel 设置
            2.2 el-carousel 的 height 样式必须设置，用来设置展示区域的宽度，通过 .el-carousel__container 设置
         3. 经过反复研究图片的尺寸大小以及 Instagram 的做法，发现将图片的尺寸高度在设计稿尺寸下固定到 600px 是最佳的做法，这样评论的显示区域
            和图片的展示，以及左右滑动的箭头之间是最协调的！
         4. 不知道 ImageViewer 的背景不透明是怎么做的，总之如果想要弹出的图片能够原色展示，则必须添加样式 transform: scale(1) rotate(0deg);
         5. 另外要让图片能够原尺寸展示，必须添加 margin-left: 0px; margin-top: 0px; max-height: 100%; max-width: 100%;
         6. Carousel 的高度和宽度需要动态的根据图片的尺寸和 carousel 的固定高度 600px 动态计算出来，这里借助到了 css 的参数 --width 的做法，
            具体参考《Vue/Vue 不常见问题.md》中的【如何更改 class 样式中的属性值】小节中的内容。
        -----------------------
        Carsousel 控制视频的播放
          现在遇到的问题是，如果是多图类型含视频的情况下，即便是没有滑动到视频，也会自动播放，浪费流量不说，用户体验不好。现在的解决办法是，当 Carsousel
          滑动到该视频的时候，由 Carsousel 控制视频的播放。
        -----------------------
        增加 Carsousel 移动端的手指滑动功能
        https://blog.csdn.net/qq_40942490/article/details/109582623
    -->
    <!-- 特别注意，构建这个组件比较好玩，swiper 不能有最外层的根元素 div，而 el-carousel 又必须有外层根元素 div-->
    <div v-if="!isPhoneAgent"> <!--注意，这个 div 千万不能移除，否则 Carsousel 不显示，目前不知道原因！-->
        <el-carousel trigger="click"
                     :autoplay="false"
                     :loop="false"
                     arrow="always"
                     :style="`--width: ${calWidth}px; --height: ${calHeight}px; --swith-button-display: ${isDisplaySwitchButton}`"
                     @change="change"
                     ref="carousel">
            <el-carousel-item v-for="(slot, id) in entity.slots" :key="slot.pic">
                <!-- 处理图片 -->
                <template v-if="slot.video == null">
                    <!--
                        注意，el-carsousel 中不允许 el-iamge 使用 lazy，否则图片不能加载。
                          1. 有人提交了一个 bug https://github.com/ElemeFE/element/issues/15381
                          2. 有人试图用 vue-lazyload 来解决 https://blog.csdn.net/caijunfen/article/details/84561504
                          3. 因为现在图片需要在 modialog 窗口中以弹出的方式展示，而 modialog 窗口默认的 z-index > 2000，因此为了保证预览图片
                             即"查看大图"的方式弹出的大图能够展示，将这里的 z-index 从 300 改成了 3000.
                    -->
                    <el-image
                        v-bind:ref="'img'+id"
                        :src="slot.pic"
                        :preview-src-list="[slot.pic]"
                        :z-index="3000"
                        style="transform: scale(1) rotate(0deg); margin-left: 0px; margin-top: 0px; max-height: 100%; max-width: 100%;"
                        @mouseenter="showOriginButton=true"
                        @mouseout="showOriginButton=false">
                        <!-- 使用具名 slot 填充 placeholder 用于展示图片加载（loading）过程 -->
                        <div slot="placeholder" :style="{height: calHeight+'px'}" style="display:flex; align-items: center">
                            <!-- 注意，要想让 iconfont 转动起来，必须在块元素 div 上添加 rotate 样式 -->
                            <div class="rotate"><i class="iconfont icon-sy-loading" style="font-size: 50px"></i></div>
                        </div>
                    </el-image>
                    <div class="show-orign" v-show="showOriginButton" @mouseenter="showOriginButton=true" @click="showOrigin(id)">查看大图</div>
                </template>
                <!-- 处理视频-->
                <template v-else>
                    <video-player :ref="'video'+id" :poster="slot.pic" :video="slot.video" :height="calHeight" :width="calWidth" :independent="isVideoIndependent(entity, id)"/>
                </template>
            </el-carousel-item>
        </el-carousel>
    </div>
    <!-- TODO 实际上只要是能够 tap 的移动端都应该支持 -->
    <swiper v-else
            ref="mySwiper"
            :style="{width: calWidth +'px', height: calHeight+'px'}"
            :options="swiperOptions"
            @slideNextTransitionEnd="slideNextTransitionEnd"
            @slidePrevTransitionEnd="slidePrevTransitionEnd">
        <template v-for="(slot, id) in entity.slots">
            <swiper-slide>
                <!--特别注意：之前这里使用了 === 来作比较，出错，BUG！-->
                <template v-if="slot.video == null">
                    <div class="swiper-zoom-container" :style="{height: calHeight+'px'}">
                        <img v-bind:ref="'img'+id" :data-src="slot.pic" :style="{width: '100%', height: '100%', objectFit: 'cover'}" class="swiper-lazy"/>
                        <div class="swiper-lazy-preloader"></div>
                    </div>
                </template>
                <!-- 处理视频-->
                <template v-else>
                    <video-player :ref="'video'+id" :poster="slot.pic" :video="slot.video" :height="calHeight" :width="calWidth" :independent="isVideoIndependent(entity, id)"/>
                </template>
            </swiper-slide>
        </template>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

</template>

<script>
    import {Entity, EntityType, isPhoneAgent, ShowEntityMode} from "../../utils";
    import util from 'util';
    import assert from 'assert';
    import VideoPlayer from "../commons/VideoPlayer";
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    const fixedHeight = 600;  // default to 600 height
    const marginSize = 40; // margin size 是 popupingEntity content window 两边到屏幕的间距！
    const commentPanelWidth = 335;  // 在 PC 端，评论端的尺寸固定为 335px
    const mobileScreenWidth = 736;  // 标准移动端的尺寸
    const maxWidth = 935; // 当屏幕超宽后，huocool 页面的最大展示宽度

    export default {
        name: "carousel",
        components: {
            VideoPlayer,
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },
        props: {
            entity: Object,
            zIndex: {
                type: Number,
                default: 300
            }
        },
        data(){
            return {
                showOriginButton: false,
                calWidth: 0,
                calHeight: 0,
                screenWidth: document.body.clientWidth,
                // 控制是否显示 next/prev entity button；TODO 这个属性到底有什么用? 我把这个属性的相关功能代码给注释掉了，没有任何影响呀..
                isDisplaySwitchButton: false,
                swiperOptions: {
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    // 这样设计的目的即是实现 Instagram 那样的效果，放大后立即缩放。
                    zoom: {
                        maxRatio: 1,
                        minRatio: 1,
                        toggle: false,
                    },
                    // Disable preloading of all images
                    preloadImages: false,
                    // Enable lazy loading
                    lazy: {
                        loadOnTransitionStart: true, // 为了更好的用户体验，这里启动预加载
                        loadPrevNext: true, // 预加载下一个
                        // loadPrevNextAmount: this.entity.slots.length  // 可以最大预加载的个数。
                        loadPrevNextAmount: 2  // 将这个值改为 2，是为了将带宽都集中下载在当前最近的几个图片上，加快响应速度。
                    },
                },
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            },
            isPhoneAgent(){
                return isPhoneAgent();
            }
        },
        /**
         * 之前，update stretch size 是放在 mounted 回调中的，但是因为 video.js 中的 options.height 值必须在 carsousel stretch
         * size 计算得出 stretch height 之后赋值，而该赋值行为由 VideoPlayer.vue 的 mounted 回调实现，因此这里改为了 before mount，
         * 目的就是为了保证 carsousel 的 stretch size 计算在 VideoPalyer.vue options.height 的赋值之前准备好！
         */
        beforeMount() {
            console.log('Carousel before mount');
            // 这里调整
            // this.isDisplaySwitchButton = this.entity.slots.length > 1 ? 'inline-block' : 'none';
            this.updateSize();
            const t = this;
            // this.calWidth = this.stretchSize();
            // 切记不要写成 window.onresize = function(){...} 的形式，因为 window.onresize 是全局唯一的
            window.addEventListener('resize', () => {
                // 赋值给 screen width，使其触发相应的 watch 事件。
                t.screenWidth = window.innerWidth;
            })
        },
        mounted(){
            console.log('Carousel mounted');
            // 奇怪了，Entity 每次切换出去都会被销毁的，但是 swiper 的 index 却保留了状态，因此每次新创建时，都需要将 swiper slide 的 curr index 重置为 0
        },
        created(){
            console.log('Carousel created')
            setTimeout(()=>{
                // 刚初始化的时候，第一张图的 caroshowing 事件需要在 create 回调中实现
                this.sendCaroshowingGlobalEvent(0);
                console.log('Carousel created, caroshowing global event get emit');
            }, 500) // 这里必须休眠足够长的时间，否则 wallpaper previewer 还没来得及初始化去监听
        },
        watch: {
            /**
             * @param value 是传递给 screenWidth 的参数值即是 window.screenWidth
             */
            screenWidth(value){
                this.screenWidth = value;
                this.updateSize();
            }
        },
        methods: {

            // 显示原图，通过找到当前这张图片（el-image），然后触发它的 click 事件即可
            showOrigin(id){
                // 注意，$ref 是一个数组。
                this.$refs['img'+id][0].clickHandler();
                // 本来应该在 image-viewer.vue 中回调下面这个方法，但是不像修改 ElementUI 的源码，等待足够时间让其渲染 img dom 即可。
                setTimeout(()=> {
                    let largeImg = document.querySelector(".el-image-viewer__canvas .el-image-viewer__img");
                    assert(largeImg !== undefined && largeImg !== null, 'the large image should be loaded');
                    console.log('show origin, imgage-viewer', largeImg);
                }, 300);
            },

            /**
             * --------------
             * 以下作为编程提醒所用，误删！
             * 注意，发现一个非常特殊的 bug，如果 carouselHeight 是定义在 data 属性中，那么如下代码
             *     data() {
             *         return {
             *             carouselHeight: 600,
             *             calWidth: this.stretchSize(),
             *         }
             *     }
             * 当调用 this.stretchSize() 方法中，this.carouselHeight = NaN，不知道为什么？因此，将 carouselHeight 定义为了 const
             * 或者可以在 mounted 生命周期回调方法中调用 stretchSize
             * --------------
             *
             * 计算出 Carsouel 用于图片展示区域的缩放宽度，具体算法参考《huocool/frontend Entity Page - 弹窗 - Carsousel 组件.md》
             * -> Carsousel 的缩放宽度计算出来以后，让图片以自适应的方式填充。
             *
             * @return {Array} [width, heigth]: String, String
             */
            stretchSize: function(){
                if(window.innerWidth > mobileScreenWidth)
                    return this._stretchPcSize();
                else
                    return this._stretchMobileSize();
            },

            /**
             * 注意
             * 1. toFixed 之后返回的是 String 类型
             * 2. 特别注意，虽然下面的描述基本上以图片的尺寸进行的描述，但是最终计算的是 Carsouel 用于展示图片区域的尺寸。
             *
             * @return the stretched Carsouel size
             */
            _stretchPcSize: function(){
                var sHeight = 0; // the stretched height of the carousel
                var sWidth = 0;  // the stretched width of the carousel
                var aWidth = this.availableWidth(); // 除去其它多余部分，最多能够用于放置 Carsousel 图片展示区域的大小。
                // 1. 设置 Carsousel 的宽度。
                // 缩放：只有当图片高度超出了 fixed height，才进行缩放
                if(this.entity.height > fixedHeight)
                    sWidth = fixedHeight / this.entity.height * this.entity.width;
                else  // 如果没有超出，则将 Carsousel 的宽度设置为图片的宽度。
                    sWidth = this.entity.width
                // 2. 设置 Carsousel 的高度
                // 2.1 表示 Carsousel 图片区域可以存放该缩放后图片的宽度，那么高度直接设置为 fixed height.
                if(aWidth > sWidth) {
                    sHeight = fixedHeight;
                }
                // 2.2 表示图片区域不能存放根据 fixedHeight 缩放后的图片，使用 aWidth 进行缩放；需要考虑如下几种特殊情况
                //  1) 在大尺寸下（screen width >= 900），将高度固定到 fixed height；主要是为了修复 HCF-113，遇到了超宽的图片，导致
                //     height 的尺寸被极度压缩（为了放下 width，height 自然被极度压缩），而导致 Carsousel 组件被撑爆了的情况。
                //  2) 在小尺寸下（screen width < 900），为了保证 information panel 能够清晰的展示，维持最小高度为 500
                else {
                    sWidth = aWidth;
                    if(window.innerWidth >= 900){  // 在大尺寸下固定 information panel 高度为 600px
                        sHeight = fixedHeight;
                    }else{
                        sHeight = sWidth / this.entity.width * this.entity.height;
                        // 在小尺寸下，为了保证 information panel 的正常显示，维持它的高度在 500px.
                        if(sHeight < 500) sHeight = 500;
                    }
                }
                // 根据当前页面的尺寸，重新布置 next/prev Entity 和关闭按钮与屏幕的间距，否则在小尺寸的屏幕下会被遮挡住！
                this.updateAuxiliaryBtnLocation(sWidth);
                // 发出 height/width 高度事件，以便 Infoboard 调整自己的高度和宽度，宽度在 PC 尺寸下固定是 335px
                this.$emit('infoboard-width', 335);
                this.$emit('infoboard-height', sHeight.toFixed(5));
                return [sWidth.toFixed(5), sHeight.toFixed(5)];
            },

            _stretchMobileSize: function(){
                var sWidth = window.innerWidth;
                var sHeight = sWidth / this.entity.width * this.entity.height;
                // spacing 事件是用来调整 next/prev popupingEntity 和弹出框关闭按钮与屏幕之间的间距的
                this.$emit('spacing', 20);
                this.$emit('infoboard-width', sWidth.toFixed(5));
                this.$emit('infoboard-height', window.innerHeight);
                return [sWidth.toFixed(5), sHeight.toFixed(5)];
            },

            /**
             * 计算出图片区域的可用宽度。335 是评论区域的固定长度；margin size 是 popupingEntity content window 两边到屏幕的间距！
             * v2 如果是 entity single page mode，那么它可以最大的展示长度就是 max width(935px) - 335px(评论区固定长度) = 600
             */
            availableWidth: function(){
                if(window.innerWidth < mobileScreenWidth){
                    return window.innerWidth;
                }
                var mode = this.$store.getters.getShowEntityMode();
                // 在 single page mode 下，且当屏幕的当前宽度超过了 maxWidth 后，可用的最大宽度必须根据 maxWidth 来计算了，而不是再通过
                // window.innerWidth 来计算了。
                if( mode === ShowEntityMode.SinglePageMode  ) {
                    if (window.innerWidth > maxWidth) {
                        var flex = 4;  // 要留几个像素
                        return maxWidth - commentPanelWidth - flex;
                    }
                }
                return window.innerWidth - marginSize*2 - commentPanelWidth;
            },

            /**
             * 根据当前屏幕尺寸计算图片最适合的尺寸。
             */
            updateSize: function(){
                var size = this.stretchSize();
                this.calWidth = parseFloat(size[0]);
                this.calHeight = parseFloat(size[1]);
            },

            /**
             * 术语：
             *   1. "next/prev Entity 按钮"和"关闭按钮"我称之为"辅助按钮"（Auxiliary Button）
             *   2. spacing 指辅助按钮与屏幕之间的标准间距的宽度，是 40px；
             * 功能：
             *   根据当前页面的尺寸，重新布置辅助按钮与屏幕的间距，否则在小尺寸的屏幕下会被遮挡住！
             * 算法：
             *   如何控制这些按钮的摆放呢？
             *   1. 当且仅当 popupingEntity content window 间距屏幕在 2 个 spacing 以上，才可以设置辅助按钮与屏幕间的间距为 40px
             *   2. 否则，辅助按钮与屏幕之间的间距为 0px，让辅助按钮与屏幕之间的间距为 0px
             */
            updateAuxiliaryBtnLocation: function(sWidth){
                // 想想如何 spacing，屏幕的宽度 - popupingEntity content window width > 2 被 next/prev 按钮的宽度，才能 spacing = 40
                // 否则 spacing = 0; 测试 900 - 950 之间的宽度。
                if( (window.innerWidth - (sWidth + commentPanelWidth)) >= 2 * (40 + 40) ){
                    // to recover the next/prvious and close item to its origin place.
                    // 必须发出事件让父组件执行，因为 next/prvious and close buttons are belongs to the parent element.
                    this.$emit('spacing', 40) // 40 是 spacing 的参数
                }else{
                    // relocate next/previous and close item to the edge of the window, orelse it is been hiden
                    // 必须发出事件让父组件执行，因为 next/prvious and close buttons are belongs to the parent element.
                    this.$emit('spacing', 0)  // 0 是 spacing 的参数
                }
            },

            /**
             * 为了避免在多图的情况下，视频自动的播放。因此，首先判断是不是多图的情况
             * 1. 如果首图即是视频，那么该 video 是 independent
             * 2. 反之，则该 video 则不是 independet，需要通过 Carsousel 来控制其播放
             * 备注：如果是 video 是 independent 则不受 Carsousel 控制，自己自动播放。
             * @param {Object} e
             * @param id, the sequence num of the slots
             * @return {Boolean}
             */
            isVideoIndependent(e, id){
                if(Entity.getType(e) === EntityType.ImageSets){
                    if(id !== 0){  //
                        return false;
                    }
                };
                return true;
            },

            /**
             * 1. 当 Carsousel 切换的时候，将会发出该 change 事件，
             * 2. 该方法将会控制多图（图集）中含有视频的自动播放和停止操作。
             *
             * 注意：
             * + id 是从 0 开始计数的。
             * + 如果是单图/单视频的情况下，不会受此影响，因为单图/单视频的时候压根不会触发该 change 事件。
             *
             * @param id, 切换后的当前 slide id
             * @param prevId，切换后的上一个 slide id
             */
            change(id, prevId){
                console.log('current slide id', id, 'the prev id', prevId);
                // 试图播放当前 slide 中的 video
                if(!util.isNullOrUndefined(this.$refs['video'+id])){
                    console.log('try to fetch the current video', this.$refs['video'+id]);
                    let currentVideo = this.$refs['video'+id][0];  // 注意返回的是一个数组，因此需要使用 [0] 取出第一个元素
                    console.log('try to auto play the current video'+id);
                    // 如果 this.$refs['video'+prevId]) 不存在，则会返回一个空数组，而 preVideo 会得到一个 undefined，所以这里必须判断
                    if(currentVideo !== undefined)
                        currentVideo.autoplay();
                }
                // 试图关闭上一个 slide 中的 video
                if(!util.isNullOrUndefined(this.$refs['video'+prevId])){
                    console.log('try to fetch the prev video', this.$refs['video'+prevId]);
                    let preVideo = this.$refs['video'+prevId][0];  // 注意返回的是一个数组，因此需要使用 [0] 取出第一个元素
                    console.log('try to auto play the prev video'+prevId);
                    // 如果 this.$refs['video'+prevId]) 不存在，则会返回一个空数组，而 preVideo 会得到一个 undefined，所以这里必须判断
                    if(preVideo !== undefined)
                        preVideo.stop();
                }
                this.sendCaroshowingGlobalEvent(id);
                console.log('Carsousel change, caroshowing global event emitted');
            },

            /**
             * @param {Number} id, the index id of the entity slots.
             */
            sendCaroshowingGlobalEvent(id){
                // 将当前正在展示的资源以 Global 事件的方式发送出去，注意，如果是第一张图，这个方法并不会被触发
                let slot = this.entity.slots[id]
                // TODO 现在认为同一个 entity 的所有资源的尺寸是相同的，如果发现不同，那么需要重构下面的逻辑
                this.$EventBus.$emit('caroshowing', {slot: slot, size: {width: this.entity.width, height: this.entity.height}, shortcode: this.entity.shortcode});
            },

            isPhoneAgent_: function(){
                return isPhoneAgent();
            },

            /**
             * vue-awesome-swiper 滑动到下一个后的回调入口
             */
            slideNextTransitionEnd: function(){
                console.log('slide to next end: the current slide index:', this.swiper.activeIndex);//切换结束时，告诉我现在是第几个slide
                // 调用 change 方法启动多图中的视频。
                this.change(this.swiper.activeIndex, this.swiper.activeIndex-1);
            },

            slidePrevTransitionEnd: function(){
                console.log('slide to prev end: the current slide index:', this.swiper.activeIndex);//切换结束时，告诉我现在是第几个slide
                // 调用 change 方法启动多图中的视频。
                this.change(this.swiper.activeIndex, this.swiper.activeIndex+1);
            }

        }
    }
</script>

<style>
    /* 调整弹出窗口背景的透视程度，注意，因为这里显示大图的 image viewer 是内部组件，因此必须设置全局属性才能生效了！ */
    .el-image-viewer__mask {
        opacity: 0.9 !important;  /* 必须使用 !important 否则发布到 nginx 之后不能生效 */
    }

    /* 屏蔽掉查看大图中的放大缩小和其他的按钮：初衷，因为图片的像素并没有那么高，如果再放大则失真了 */
    /* 最后想了想，PC 端还是保留它 */
    /*.el-image-viewer__actions{*/
    /*    display: none;*/
    /*}*/

    /* 覆盖 vue-awesome-swiper 的图片加载 spinner 的样式，将它的颜色覆盖为红色，注意覆盖后 border-top-color 会丢失，需要继续覆盖*/
    .swiper-lazy-preloader{
        border: 2px solid #CB0101 !important;
        border-top-color: transparent !important;  /* 这个属性有意思了，让圆圈的顶部没有 */
    }


</style>

<style scoped>
    /** 定义 css 变量 **/
    :root{
        --width: 0;   /* 图片等比例缩放后的宽度 */
        --height: 0;  /* 图片等比例缩放后的高度 */
        --swith-button-display: inline-block;
    }

    .show-orign {
        position:relative;
        margin-top:-50px;
        cursor:pointer;
        color:papayawhip;
    }

    /* 设置 carousel 的宽度：适配图片的宽度 */
    /deep/ .el-carousel {
        width: var(--width);
    }

    /* 设置 carousel 的高度，也是图片的固定高度 */
    /deep/ .el-carousel__container {
        height: var(--height)
    }

    /* 设置 next/prev image button 的样式 */
    /deep/ .el-carousel__arrow{
        width: 30px !important;  /* 通过 width/height 调整 button 大小 */
        height: 30px !important;
        background-color: black !important;
        opacity: .65 !important;
        /*display: var(--swith-button-display);*/
    }

    /deep/ .el-carousel__button{
        width: 6px !important;
    }

    @media (min-width: 976px) {

        /deep/ .el-carousel {
            width: var(--width);
        }

        /deep/ .el-carousel__container {
            height: 600px
        }
    }

    @media (max-width: 735px) {

        /deep/ .el-carousel {
            z-index: 0; /* 否则弹窗后的关闭按钮不再显示了 */
        }

        /deep/ .el-carousel__container {
            -webkit-overflow-scrolling: touch;
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/entity/Carousel.vue